const SESSION_STORAGE_KEY = 'track_access_sessions'
const SESSION_TTL_MS = 30 * 24 * 60 * 60 * 1000

let currentAccessToken = null
let currentBypassKey = null

export function setCurrentAccessToken(token) {
  currentAccessToken = token || null
}

export function getCurrentAccessToken() {
  return currentAccessToken
}

export function setCurrentBypassKey(key) {
  currentBypassKey = key || null
}

export function getCurrentBypassKey() {
  return currentBypassKey
}

export function resolveBypassKey(urlParams) {
  for (const name of ['k', 'h', 'key']) {
    const value = urlParams.get(name)
    if (value) {
      return value
    }
  }
  return null
}

function readSessions() {
  try {
    const raw = localStorage.getItem(SESSION_STORAGE_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

function writeSessions(sessions) {
  localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(sessions))
}

export function getStoredSession(orderId) {
  const sessions = readSessions()
  const entry = sessions[String(orderId)]
  if (!entry?.access_token || !entry?.expires_at) {
    return null
  }
  if (Date.now() > entry.expires_at) {
    delete sessions[String(orderId)]
    writeSessions(sessions)
    return null
  }
  return entry.access_token
}

export function saveSession(orderId, accessToken) {
  const sessions = readSessions()
  sessions[String(orderId)] = {
    access_token: accessToken,
    expires_at: Date.now() + SESSION_TTL_MS,
  }
  writeSessions(sessions)
  setCurrentAccessToken(accessToken)
}

export function buildAccessQueryParams() {
  const params = {}
  const token = getCurrentAccessToken()
  const bypass = getCurrentBypassKey()
  if (token) {
    params.access_token = token
  }
  if (bypass) {
    params.k = bypass
  }
  return params
}
